import { useEffect } from "react";
import { Row, Col, Card } from "react-bootstrap";
import "../../amazon-ads.scss";
import HelperService from "../../../../Services/HelperService";
const OverviewCards = (props: any) => {
  useEffect(() => {}, []);
  return (
    <div>
      <Card className="overview-card">
        <Row className="">
          <Col>
            <div className="cursor-pointer text-center border-end">
              <div>
                {" "}
                <div className="text-secondary font-14 mb-1 font-400">ACOS</div>
                <div className="font-18 font-bold">
                  {props.overview.ACOS
                    ? HelperService.numberWithCommas(props.overview.ACOS)
                    : 0}
                  %
                </div>
              </div>
            </div>
          </Col>
          <Col>
            <div className=" cursor-pointer text-center border-end">
              <div>
                {" "}
                <div className="text-secondary font-14 mb-1 font-400">ROAS</div>
                <div className="font-18 font-bold">
                  {props?.overview?.ROAS
                    ? HelperService.numberWithCommas(props?.overview?.ROAS)
                    : 0}
                </div>
              </div>
            </div>
          </Col>
          <Col>
            <div className=" cursor-pointer text-center border-end">
              <div>
                {" "}
                <div className="text-secondary font-14 mb-1 font-400">
                  Spend
                </div>
                <div className="font-18 font-bold">
                  <span className="font-18 font-bold">$</span>
                  {props.overview.spend
                    ? HelperService.numberWithCommas(props.overview.spend)
                    : 0}
                </div>
              </div>
            </div>
          </Col>
          <Col>
            <div className=" cursor-pointer text-center border-end">
              <div>
                {" "}
                <div className="text-secondary font-14 mb-1 font-400">
                  Sales
                </div>
                <div className="font-18 font-bold">
                  <span className="font-18 font-bold">$</span>
                  {props.overview.sales
                    ? HelperService.numberWithCommas(props.overview.sales)
                    : 0}
                </div>
              </div>
            </div>
          </Col>
          <Col>
            <div className=" cursor-pointer text-center border-end">
              <div>
                {" "}
                <div className="text-secondary font-14 mb-1 font-400">
                  Clicks
                </div>
                <div className="font-18 font-bold">
                  {" "}
                  {props.overview.clicks
                    ? HelperService.numberWithCommas(props.overview.clicks)
                    : 0}
                </div>
              </div>
            </div>
          </Col>
          <Col>
            <div className=" cursor-pointer text-center border-end">
              <div>
                {" "}
                <div className="text-secondary font-14 mb-1 font-400">
                  Impression
                </div>
                <div className="font-18 font-bold">
                  {" "}
                  {props.overview.impressions
                    ? HelperService.numberWithCommas(props.overview.impressions)
                    : 0}
                </div>
              </div>
            </div>
          </Col>
          <Col>
            <div className="cursor-pointer text-center ">
              <div>
                {" "}
                <div className="text-secondary font-14 mb-1 font-400">
                  Orders
                </div>
                <div className="font-18 font-bold">
                  {" "}
                  {props.overview.purchases
                    ? HelperService.numberWithCommas(props.overview.purchases)
                    : 0}
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default OverviewCards;
